import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' }
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('auth_token');
      localStorage.removeItem('auth_user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  verify2FA: (data) => api.post('/auth/verify-2fa', data),
  setup2FA: () => api.post('/auth/setup-2fa'),
  enable2FA: (data) => api.post('/auth/enable-2fa', data),
  disable2FA: () => api.post('/auth/disable-2fa'),
  me: () => api.get('/auth/me'),
  createEmployeeAccount: (data) => api.post('/auth/create-employee-account', data),
};

// Invitation Codes
export const invitationCodesAPI = {
  list: () => api.get('/invitation-codes'),
  create: (data) => api.post('/invitation-codes', data),
  delete: (id) => api.delete(`/invitation-codes/${id}`),
};

// Companies
export const companiesAPI = {
  list: () => api.get('/companies'),
  create: (data) => api.post('/companies', data),
  update: (id, data) => api.put(`/companies/${id}`, data),
  delete: (id) => api.delete(`/companies/${id}`),
};

// Employees
export const employeesAPI = {
  list: () => api.get('/employees'),
  create: (data) => api.post('/employees', data),
  update: (id, data) => api.put(`/employees/${id}`, data),
  delete: (id) => api.delete(`/employees/${id}`),
  recap: (id, params) => api.get(`/employees/${id}/recap`, { params }),
};

// Shifts
export const shiftsAPI = {
  getWeek: (weekStart) => api.get('/shifts', { params: { week_start: weekStart } }),
  create: (data) => api.post('/shifts', data),
  update: (id, data) => api.put(`/shifts/${id}`, data),
  delete: (id) => api.delete(`/shifts/${id}`),
  copyWeek: (data) => api.post('/shifts/copy-week', data),
};

// Overtime
export const overtimeAPI = {
  get: (employeeId) => api.get(`/overtime/${employeeId}`),
  adjust: (employeeId, data) => api.put(`/overtime/${employeeId}/adjust`, data),
  history: (employeeId) => api.get(`/overtime/${employeeId}/history`),
};

// Summary
export const summaryAPI = {
  weekly: (weekStart) => api.get('/weekly-summary', { params: { week_start: weekStart } }),
};

// Week Templates
export const templatesAPI = {
  list: () => api.get('/week-templates'),
  save: (data) => api.post('/week-templates', data),
  apply: (id, data) => api.post(`/week-templates/${id}/apply`, data),
  delete: (id) => api.delete(`/week-templates/${id}`),
};

// Admin Dashboard
export const adminAPI = {
  dashboard: () => api.get('/admin/dashboard'),
};

// Export
export const exportAPI = {
  monthlyPDF: (month) => api.get('/export/monthly-pdf', { params: { month }, responseType: 'blob' }),
};

export default api;
